module.exports = __webpack_public_path__ + "img/caja2.c91c9873.png";